import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/api/candidate/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Request failed');
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successIcon}>📧</div>
          <h1 style={styles.title}>Check Your Email</h1>
          <p style={styles.text}>
            If an account exists with <strong>{email}</strong>, you'll receive a password reset link shortly.
          </p>
          <p style={styles.text}>
            Please check your inbox and follow the instructions to reset your password.
          </p>
          <Link to="/login" style={styles.link}>
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.logo}>H</h1>
          <h2 style={styles.title}>Forgot Password?</h2>
          <p style={styles.subtitle}>Enter your email to reset your password</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}

          <div style={styles.formGroup}>
            <label style={styles.label}>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
              placeholder="your.email@example.com"
            />
          </div>

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={styles.footer}>
          <Link to="/login" style={styles.backLink}>
            ← Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a2f4d 0%, #2a4d6d 100%)',
    padding: '20px',
    fontFamily: "'Open Sans', sans-serif",
  },
  card: {
    background: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
    maxWidth: '450px',
    width: '100%',
    padding: '40px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  logo: {
    width: '60px',
    height: '60px',
    background: '#ff6b35',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
    fontWeight: 800,
    color: '#fff',
    margin: '0 auto 20px',
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#1a2f4d',
    margin: '0 0 10px',
    fontFamily: "'Montserrat', sans-serif",
  },
  subtitle: {
    fontSize: '14px',
    color: '#6c757d',
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1a2f4d',
  },
  input: {
    padding: '12px 16px',
    border: '1px solid #dee2e6',
    borderRadius: '6px',
    fontSize: '15px',
    transition: 'border-color 0.2s',
    outline: 'none',
  },
  error: {
    padding: '12px',
    background: '#fee',
    border: '1px solid #fcc',
    borderRadius: '6px',
    color: '#d33',
    fontSize: '14px',
  },
  button: {
    padding: '14px',
    background: '#ff6b35',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.2s',
    marginTop: '10px',
  },
  footer: {
    marginTop: '30px',
    textAlign: 'center',
  },
  backLink: {
    fontSize: '14px',
    color: '#ff6b35',
    textDecoration: 'none',
    fontWeight: 600,
  },
  successIcon: {
    fontSize: '64px',
    textAlign: 'center',
    marginBottom: '20px',
  },
  text: {
    fontSize: '14px',
    color: '#6c757d',
    margin: '0 0 15px',
    textAlign: 'center',
    lineHeight: 1.6,
  },
  link: {
    display: 'block',
    padding: '12px',
    background: '#1a2f4d',
    color: '#fff',
    textAlign: 'center',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: 600,
    marginTop: '20px',
  },
};
